module.exports = __webpack_public_path__ + "img/4.681baff9.png";